import 'reflect-metadata'
import { injectable } from 'inversify-props'
import { findClassificacaoTributariaByCodigo, findAllClassificaoTributaria } from '@/api/impostos'
import type { ClassificacaoTributariaServiceAdapter } from '@/usecases/impostos/adapter/ClassificacaoTributariaServiceAdapter'

@injectable()
export class ClassificacaoTributariaService implements ClassificacaoTributariaServiceAdapter {
	findByCodigo = async (codigo: string) => await findClassificacaoTributariaByCodigo(codigo)
	findAll = async () => await findAllClassificaoTributaria()
}
